goog.provide('el8.appchart.dialog.ordermed.discontinueFormDialog');

goog.require('el8.model.base');
goog.require('el8.ptdata.dcMedOrders');
goog.require('el8.uiwidget.Form');
goog.require('el8.uiwidget.FormDialog');
goog.require('el8.util.validate');
goog.require('el8.util.consts');
goog.require('el8.appservice.search');
goog.require('el8.service.tz');
goog.require('el8.util.datecompare');
goog.require('el8.template.appchart.dialog.discontinueRx');
goog.require('el8.appchart.dialog.selectPrescribingPhysician');
goog.require('el8.appshared.mindreaderOpts');
goog.require('el8.data.base');
goog.require('el8.app.shared.clickItemOpts');


el8.appchart.dialog.ordermed.discontinueFormDialog = function(spec) {

    spec = spec || {};

    this._medOrderSelector = '#discontinue-rx-med-info';
    this._isDocumented = (spec.isDocumented === true);
    this._saveCallbackFn = null;
    var that = this;

    spec.contentFn = function() {
        return el8.template.appchart.dialog.discontinueRx.content({
            isDocumented: that._isDocumented
        });
    };
    el8.uiwidget.FormDialog.call(this, spec);

    var _fields = [];
    _fields.addArray([
        {
            name: 'reason',
            selector: ':input[name="reason"]',
            infoText: 'reason for discontinuing med...',
            maxLength: 100
        },
        {
            name: 'discontinueDate',
            selector: ':input[name="discontinueDate"]',
            infoText: 'date discontinued...',
            datePickerOpts: {},
            validate: {
                validDate: true,
                afterYear1900: true
            }
        }
    ]);
    if (this._isDocumented) {
        _fields.addArray(
            [{
                name: 'prescriber',
                selector: '.prescriber-field',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                infoText: 'physician...',
                clickItemOpts: el8.app.shared.clickItemOpts.physicians({
                    newContactCb: function(contact) {
                        if (!contact) { return; }
                        form.setClickItemSelected('prescriber', {
                            id: contact.getId(),
                            name: contact.getFullName()
                        });
                    }
                })
            }]
        );
    }

    var form = new el8.uiwidget.Form({
        fields: _fields,
        validationOpts: el8.util.validate.standardOpts
    });
    form.addButton('discontinue', that._isDocumented ? 'Save & Close' : 'Discontinue', function(_form) {
        var dcMedOrder = el8.ptdata.model.med.dcMedOrder({
            model_class: "DiscontinueMedOrder",
            med_order_id: that._medOrder.getId(),
            reason: _form.getVal('reason'),
            discontinue_date: _form.getVal('discontinueDate'),
            is_documented: that._isDocumented,
            prescribing_physician_id: that._isDocumented ?
                _form.getClickItemId('prescriber') : null,
            manual_prescribing_physician_name: _form.getVal('prescriber')
        });
        var doDiscontinueFn = function(order) {
            if (that._isDocumented) {
                that._doSave(order);
                return;
            }

            var currUser = el8.data.currUser;
            var delegatingPhysicians = currUser.getRxDelegatingPhysicianIdsInWorkspace();
            if (delegatingPhysicians.length) {
                if (delegatingPhysicians.length === 1) {
                    order.setPrescribingPhysicianId(delegatingPhysicians[0]);
                    that._doSave(order);
                } else {
                    el8.appchart.dialog.selectPrescribingPhysician.show('rxs', function(physicianId) {
                        order.setPrescribingPhysicianId(physicianId);
                        that._doSave(order);
                    });
                }
            } else if (currUser.isPhysician()) {
                order.setPrescribingPhysicianId(currUser.getStaffId());
                that._doSave(order);
            }
        };

        if (!_form.getVal('discontinueDate')) {
            el8.uiwidget.alert('Please enter a discontinue date.');
            return;

        } else if (el8.util.datecompare.isAfterToday(el8.service.tz.newTzDate(_form.getVal('discontinueDate')))) {
            el8.uiwidget.confirm(
                'You have entered a discontinue date in the future. Are you sure you want to continue saving?',
                function() { doDiscontinueFn(dcMedOrder); },
                function() { _form.getInputField('discontinueDate').focusFocus(); }
            );
            return;
        } else if (that._threadLatestOrder.getStartDate() > el8.service.tz.newTzDate(_form.getVal('discontinueDate'))) {
            el8.uiwidget.confirm(
                'Your discontinue date is earlier than the last activity date for this med! This med will still appear in your medication list. Are you sure you want to continue saving?',
                function() { doDiscontinueFn(dcMedOrder); },
                function() { _form.getInputField('discontinueDate').focusFocus(); }
            );
            return;
        }
        // Do save
        doDiscontinueFn(dcMedOrder);
    }, true);
    if (that._isDocumented) {
        form.addDiscardButton(function() {
            that.hide();
        });
    } else {
        form.addCancelButton(function() {
            that.hide();
        });
    }
    this.setForm(form);

};
el8.appchart.dialog.ordermed.discontinueFormDialog.inheritsFrom(el8.uiwidget.FormDialog);

el8.appchart.dialog.ordermed.discontinueFormDialog.prototype.show = function(spec) {
    spec = spec || {};
    el8.uiwidget.FormDialog.prototype.show.apply(this, arguments);

    this._saveCallbackFn = spec.saveCallbackFn || null;

    this._medOrder = spec.order;
    var thread = el8.ptdata.medOrderThreads.getById(this._medOrder.getThreadId());
    this._threadLatestOrder = thread.getLatestOrder();
    var threadSoyMap = thread.asSoyMap();
    threadSoyMap['latestActivityDate'] = thread.getLatestActivityDate();
    $(this._medOrderSelector, this.getContainer()).html(
        el8.template.appchart.dialog.discontinueRx.threadInfo(threadSoyMap));

    this._form.setVal('discontinueDate', el8.service.tz.today().asString());

    if (this._isDocumented) {
        this._populatePrescriber();
    }

    this.adjustHeight();
};

el8.appchart.dialog.ordermed.discontinueFormDialog.prototype._doSave = function(dcMedOrder) {
    var that = this;
    el8.ptdata.dcMedOrders.saveItem(dcMedOrder, false, {
        successCb: function() {
            that.hide();
            el8.appchart.mgr.notes.addNewOrder(dcMedOrder);
            if (that._saveCallbackFn) { that._saveCallbackFn(dcMedOrder); }
        }
    });
};

el8.appchart.dialog.ordermed.discontinueFormDialog.prototype._populatePrescriber = function() {
    if (!this._isDocumented) { return; }
    if (this._medOrder && this._medOrder.getPrescribingPhysicianId()) {
        this._form.setClickItemSelected('prescriber', {
            id: this._medOrder.getPrescribingPhysicianId(),
            name: this._medOrder.getPrescribingPhysicianName()
        });
    } else if (el8.data.currUser.isPhysician()) {
        this._form.setClickItemSelected('prescriber', {
            id: el8.data.currUser.getStaffId(),
            name: el8.data.currUser.getFullName()
        });
    }
};

